export default Object.freeze({
  // values here are base on WebshopPageComponentType.java
  ADVERT: 'ADVERT',
  BOP: 'BOP',
  COUPONS_FOP: 'COUPONS_FOP',
  COUPONS_PROMO_FOP: 'COUPONS_PROMO_FOP',
  FOP_BASKET: 'FOP_BASKET',
  FOP_REGULAR: 'FOP_REGULAR',
  FOP_SPONSORED: 'FOP_SPONSORED',
  FOP_SUBSCRIPTIONS: 'FOP_SUBSCRIPTIONS',
  FOP_SUGGESTED_ORDER: 'FOP_SUGGESTED_ORDER',
  OR_AVAILABLE_SLOTS: 'OR_AVAILABLE_SLOTS',
  OR_NO_SLOTS_AVAILABLE: 'OR_NO_SLOTS_AVAILABLE',
  OR_ORDER: 'OR_ORDER',
});
